export const baseUrl = "https://house-hunt-service-1089456023483.asia-south1.run.app/api/v1";
export const productName = "GL Funnel";
export const clientCompanyName = "House Hunt";
export const spinWheelUrl ="https://househuntrewards.in";